var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.posting, loading: _vm.$apollo.loading } },
        [
          _c("PostingHeader", {
            attrs: { posting: _vm.posting, currentUserId: _vm.currentUser.id },
            on: { applicationUpdated: _vm.refetchData },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function () {
                  return [
                    _vm.application
                      ? _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c("ApplicationNote", {
                              attrs: {
                                currentUserId: _vm.currentUser.id,
                                applicationId: _vm.application.id,
                                postingId: _vm.posting.id,
                                jobTitle: _vm.posting.job_title,
                                companyName: _vm.company.business_name,
                                location: _vm.posting.location,
                                employmentType: _vm.posting.employment_type,
                                duration: _vm.posting.duration,
                                postedDate: _vm.formattedCreatedAt,
                                description: _vm.posting.description,
                                note: _vm.contractorNote,
                                skills: _vm.skills,
                                industries: _vm.industries,
                                attachedDocumentId: _vm.application.document_id,
                              },
                              on: { applicationNoteUpdated: _vm.refetchData },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col w-full mt-5 h-auto pb-5 gap-8 customShadowBottom bg-white transition delay-75 duration-200 ease-in-out",
            },
            [
              _c("div", { staticClass: "capitalize bg-white routeBlock" }, [
                _c(
                  "div",
                  { staticClass: "border-b border-gray-200 px-8 pt-4 pb-3.5" },
                  [
                    _c("nav", { staticClass: "-mb-px flex" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "whitespace-no-wrap pb-1 border-b-2 border-transparent border-secondary-black font-normal text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-gray-300",
                          attrs: { href: "#" },
                        },
                        [_vm._v(" Details ")]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm.application
                ? _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("ApplicationAttachment", {
                        staticClass: "mr-2 ml-auto px-5",
                        attrs: {
                          currentUserId: _vm.currentUser.id,
                          applicationId: _vm.application.id,
                          postingId: _vm.posting.id,
                          jobTitle: _vm.posting.job_title,
                          companyName: _vm.company.business_name,
                          location: _vm.posting.location,
                          employmentType: _vm.posting.employment_type,
                          duration: _vm.posting.duration,
                          postedDate: _vm.formattedCreatedAt,
                          description: _vm.posting.description,
                          skills: _vm.skills,
                          industries: _vm.industries,
                          attachedDocumentId: _vm.application.document_id,
                          buttonVariant: "outline-black",
                        },
                        on: { applicationNoteUpdated: _vm.refetchData },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.company
                ? _c("div", { staticClass: "gap-3 flex flex-col px-8" }, [
                    _c("p", { staticClass: "font-normal text-lg" }, [
                      _vm._v(" Company "),
                    ]),
                    _c("div", { staticClass: "flex flex-col gap-2" }, [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2" },
                        [
                          _vm.companyLogo
                            ? _c(
                                "div",
                                { staticClass: "b-company_image w-9 h-9" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.companyLogo,
                                      alt: _vm.company.business_name,
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "RouterLink",
                            {
                              attrs: {
                                to: {
                                  name: _vm.routes.NETWORK_COMPANY,
                                  params: { id: _vm.company.id },
                                },
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-primary-500 cursor-pointer inline",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.company.business_name) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.company.country || _vm.company.city
                        ? _c(
                            "div",
                            { staticClass: "flex gap-3 items-center" },
                            [
                              _vm.company.city
                                ? _c(
                                    "p",
                                    { staticClass: "text-gray-400 text-sm" },
                                    [
                                      _vm._v(
                                        "City: " + _vm._s(_vm.company.city)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.company.country
                                ? _c(
                                    "p",
                                    { staticClass: "text-gray-400 text-sm" },
                                    [
                                      _vm._v(
                                        "Country: " +
                                          _vm._s(_vm.company.country)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "gap-2 flex flex-col px-8" }, [
                _c("p", { staticClass: "font-normal text-lg" }, [
                  _vm._v(" About "),
                ]),
                _c("p", { staticClass: "text-storm-gray text-basetext-sm" }, [
                  _vm._v("Duration: " + _vm._s(_vm.jobDuration || "n/a")),
                ]),
                _vm.type
                  ? _c(
                      "p",
                      { staticClass: "text-storm-gray text-basetext-sm" },
                      [_vm._v("Role: " + _vm._s(_vm.type))]
                    )
                  : _vm._e(),
                _c("p", { staticClass: "text-storm-gray text-basetext-sm" }, [
                  _vm._v("Budget: " + _vm._s(_vm.getBudet)),
                ]),
              ]),
              _vm.posting?.description
                ? _c("div", { staticClass: "gap-3 flex flex-col px-8" }, [
                    _c("p", { staticClass: "font-normal text-lg" }, [
                      _vm._v("Description"),
                    ]),
                    _c(
                      "span",
                      { staticClass: "text-storm-gray text-base break-words" },
                      [_vm._v(_vm._s(_vm.posting.description))]
                    ),
                  ])
                : _vm._e(),
              _vm.skills?.length
                ? _c(
                    "div",
                    { staticClass: "flex flex-col gap-3 px-8" },
                    [
                      _c("p", { staticClass: "font-normal text-lg" }, [
                        _vm._v("Skills "),
                        _c("span", { staticClass: "text-gray-400" }, [
                          _vm._v("(" + _vm._s(_vm.skills?.length) + ")"),
                        ]),
                      ]),
                      _c("ItemChipsWithMore", {
                        attrs: {
                          showAll: true,
                          items: _vm.skills,
                          fullItem: true,
                          title: "",
                          limit: 100,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.industries?.length
                ? _c(
                    "div",
                    { staticClass: "flex flex-col gap-3 px-8" },
                    [
                      _c("p", { staticClass: "font-normal text-lg" }, [
                        _vm._v("Tags "),
                        _c("span", { staticClass: "text-gray-400" }, [
                          _vm._v("(" + _vm._s(_vm.industries?.length) + ")"),
                        ]),
                      ]),
                      _c("ItemChipsWithMore", {
                        attrs: {
                          showAll: true,
                          items: _vm.industries,
                          fullItem: true,
                          title: "",
                          limit: 100,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", [
                _c("h2", { staticClass: "font-semibold mb-7 px-8" }, [
                  _vm._v("Submission Details"),
                ]),
                _vm.contractorAddedComment ||
                _vm.contractorNote ||
                _vm.attachmentFileName ||
                _vm.getIsapplied
                  ? _c("div", { staticClass: "flex flex-col px-8" }, [
                      _vm.contractorAddedComment
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col gap-2 mb-4" },
                            [
                              _c("p", { staticClass: "font-normal text-lg" }, [
                                _vm._v("My Comments"),
                              ]),
                              _vm.contractorNote
                                ? _c("p", { staticClass: "text-sm" }, [
                                    _vm._v(_vm._s(_vm.contractorNote)),
                                  ])
                                : _vm._e(),
                              _vm.commentsDividerShown
                                ? _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [_c("ModalSectionsDivider")],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        [
                          _vm.attachmentFileName
                            ? _c("DocumentProvider", {
                                attrs: {
                                  document: _vm.application.document,
                                  currentUserRole: _vm.currentUser.role,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ download }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center mr-2",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Attachment:"),
                                              ]),
                                              _c(
                                                "ColorIconContainer",
                                                {
                                                  staticClass:
                                                    "w-full flex items-center",
                                                  on: { click: download },
                                                },
                                                [
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-primary-500 text-sm",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.attachmentFileName
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("DownloadIcon", {
                                                      staticClass: "w-6 h-4",
                                                    }),
                                                  ],
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  10764180
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.getIsapplied
                        ? _c("p", { staticClass: "text-sm" }, [
                            _vm._v(
                              " Date Applied: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.application?.created_at,
                                    "D MMM, YYYY"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "px-8" }, [
                      _c("p", { staticClass: "font-normal text-base" }, [
                        _vm._v("No details added."),
                      ]),
                    ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }